<template>
        <div class="modal-card ">
                <header class="modal-card-head"  >

                    <p class="modal-card-title "   >Blood Parasite Management</p>
 

                </header>
                <section class="modal-card-body"  >
                    <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
                    <b-tabs type="is-boxed" v-model="mainTab">

                        <b-tab-item>
                            <template #header>
                                <b-icon icon="format-list-bulleted"></b-icon>
                                <span> List of Blood Parasite <b-tag rounded type="is-info"> {{dataBlParasiteMaster.length}} </b-tag> </span>
                            </template>


                            <nav class="level is-mobile">
                                <div class="level-left">
                                    <div class="level-item">
                                        <b-button
                                                  type="is-success"
                                                  icon-left="plus"
                                                  @click="addNew">
                                            Add
                                        </b-button>
                                    </div>
                                    <div class="level-item">
                                         <b-button
                                            type="is-primary"
                                            icon-left="refresh"
                                            @click="loadDat"
                                    >Refresh</b-button>
                                    </div>

                                </div>
                                <div class="level-right">
                                  <div class="level-item">
                                        <b-button
                                                  icon-left="order-alphabetical-ascending"
                                                  type="is-primary is-light" 
                                                  @click="orderUpdate">
                                           Order Update
                                        </b-button>
                                    </div>
                                </div>
                            </nav>





                            <b-table
                                    :data="isEmpty ? [] : dataBlParasiteMaster"
                                    bordered
                                    striped
                                    narrowed
                                    hoverable
                                    focusable
                                    mobile-cards


                                    draggable
                                    @dragstart="dragstartCUS1"
                                    @drop="dropCUS1"
                                    @dragover="dragoverCUS1"
                                    @dragleave="dragleaveCUS1"



                                    >

                                <b-table-column  label="No."  width="5%" v-slot="props">
                                    {{ dataBlParasiteMaster.indexOf(props.row) + 1 }}
                                </b-table-column>        
                                <b-table-column   label="Name" v-slot="props" width="40%">
                                    {{ props.row.name }}
                                </b-table-column>
                                <b-table-column   label="Status" v-slot="props">
                                       <b-icon
                                            :icon="props.row.enable ? `check-circle` : `stop-circle` "
                                            :type="props.row.enable ? `is-success` : `is-danger` "
                                            size="is-medium">
                                      </b-icon>

                                      {{props.row.enable ? 'ใช้งาน' : 'ยกเลิก'}}
                                </b-table-column>

                                <b-table-column   label="Result Available"     centered v-slot="props" width="20%">
                                    <b-field position="is-centered">
                                        <p class="control"  v-for="datResult in props.row.result_dat_aval.id" :key="datResult" >
                                            <span class="button is-static" expanded>{{datResult}}</span>
                                        </p>


                                    </b-field>

                                </b-table-column>

                                <b-table-column   label="#"     centered v-slot="props">
                                    <b-button type="is-warning"  icon-left="pencil" @click="edit(props.row)">Edit</b-button>
                                </b-table-column>
<!-- 
                                <b-table-column   label="#"     centered v-slot="props">
                                      {{props.row.uuid }}
                                </b-table-column>

                                <b-table-column   label="#"     centered v-slot="props">
                                      {{props.row.order_ }}
                                </b-table-column> -->



                                <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                        icon="emoticon-sad"
                                                        size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>


                        </b-tab-item>





                        <b-tab-item>
                            <template #header>
                                <b-icon icon="pencil"></b-icon>
                                <span  v-if=" modeTabNewEdit===2"> Edit <b-tag rounded type="is-warning" v-if="idEdit.name.length>0"> {{idEdit.name}} </b-tag> </span>
                                <span  v-if=" modeTabNewEdit===1"> Add   <b-tag rounded type="is-success"  >  New </b-tag> </span>
                            </template>


                            <div class="container box">

                                <b-field label="Name"
                                         :type="{ 'is-danger': hasMaxOverLenght || hasNameNotValid }"
                                         :message="{ 'invalid data': hasMaxOverLenght || hasNameNotValid}" >
                                    <template slot="label">
                                    Name <span :class=" [ idEdit.name.length>GLOBAL_VAR.MAX_CHAR_BL_PARASITE_NAME ?`has-text-danger` : `has-text-primary` , `is-italic`] "
                                                v-if="idEdit.name.length>0">
                                                     ({{idEdit.name.length}}/{{GLOBAL_VAR.MAX_CHAR_BL_PARASITE_NAME}})
                                              </span>
                                    </template>
                                    <b-input v-model="idEdit.name"></b-input>
                                </b-field>


                            
 
                                

                                <b-field grouped label="Result"
                                         :type="{ 'is-danger':  hasResultTypeNotValid }"
                                         :message="{ 'invalid data': hasResultTypeNotValid }"  >
                                          

                                        <b-taglist>
                                            <b-input v-if="idEdit.result_dat_aval.length===0" disabled></b-input>
                                            <b-tag type="is-light" size="is-medium" v-for="dataRes in idEdit.result_dat_aval.id"  :key="dataRes">
                                                {{dataRes}}
                                            </b-tag>
                                        </b-taglist>

                                           <p class="control">
                                                        <b-checkbox-button 
                                                            v-model="isChkboxChangeResult"
                                                            native-value="more"
                                                            type="is-danger"
                                                            size="is-small">
                                                            <b-icon icon="magnify"></b-icon>
                                                            <span>Find other</span>
                                                        </b-checkbox-button>
                                           </p>
                                            
                                         
                           


                                </b-field>


                                <b-field label="" v-if="isChkboxChangeResult.length>0">  
                                    <ResultBloodParasiteMaster 
                                    @newSelected = "newSelectedResult"
                                    @close = "closeResultBloodParasiteMaster"
                                    />
                                </b-field>



                                <b-field label="Status">
                                    <b-switch v-model="idEdit.enable"  type="is-primary"/>
                                    <p v-if="idEdit.enable" class="has-text-info">ใช้งาน</p>
                                    <p v-else class="has-text-danger">ยกเลิก</p>
                                </b-field>

                                <br>
                                <b-button type="is-success"  icon-left="cloud-upload"  outlined @click="saveDat">Save</b-button>
                            </div>




 
 


                        </b-tab-item>

                    </b-tabs>






                </section>
                <footer class="modal-card-foot">

                    <b-button size="is-medium" type="is-danger"
                              icon-left="close" @click="close">
                        Close
                    </b-button>
                </footer>


              


            </div>
</template>

<script>

import axios from "axios";
import { getBaseURLforBackEnd ,getConfigAxios ,DATA_BL_PARASITE_MODEL , MAX_CHAR_BL_PARASITE_NAME , genUUID}  from '@/utils.js'
import ResultBloodParasiteMaster from '../BloodParasite/ResultBloodParasiteMaster.vue'
import { mapState } from "vuex";

export default {
    name : "BloodParasiteDashboard",
    components:{
        ResultBloodParasiteMaster,
    },
    created() {
        const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
            this.close()

            next(false)
        })

        this.$once('hook:destroyed', () => {
            unregisterRouterGuard()
        })
    },
 
    computed:{
          ...mapState({
                access_token : state => state.master_data.access_token,
            }) ,
            GLOBAL_VAR(){
                return { MAX_CHAR_BL_PARASITE_NAME }
            },
    },
    props:{
            isComponentModalActive : Boolean
    },
    methods:{
        orderUpdate(){
           const datTo = this.dataBlParasiteMaster.map(dat=>{
                return {
                    "id" : dat.id ,
                    "order_" : dat.order_
                }
             })



            // console.log(JSON.stringify(datTo))
            axios.defaults.headers.common['Authorization'] =  `Bearer ${this.access_token}`
            axios.post(`${getBaseURLforBackEnd()}/api/update_blparasite_order`, datTo, getConfigAxios())
                    .then((res)=>{
                       this.isLoadingFullPage = false  
                       this.$buefy.toast.open({
                            duration: 1200,
                            message: `${res.data.msg}`,
                            type: 'is-primary'
                        })
                    })
                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })

                        this.isLoadingFullPage = false
                    })




        },










     
        swapArrayElementsCUS1 (arr, indexA, indexB) {
            var temp = arr[indexA];
            arr.splice(indexA,1)
            arr.splice(indexB,0,temp)
        },
        dragstartCUS1 (payload) {
            this.draggingRow = payload.row
            this.draggingRowIndex = payload.index
            payload.event.dataTransfer.effectAllowed = 'copy'
        },
        dragoverCUS1(payload) {
            payload.event.dataTransfer.dropEffect = 'copy'
            payload.event.target.closest('tr').classList.add('is-selected')
            payload.event.preventDefault()
        },
        dragleaveCUS1(payload) {
            payload.event.target.closest('tr').classList.remove('is-selected')
            payload.event.preventDefault()
        },
        dropCUS1(payload) {
            payload.event.target.closest('tr').classList.remove('is-selected')
            const droppedOnRowIndex = payload.index
            this.$buefy.toast.open({
                message: `Moved ${this.draggingRow.first_name} from row ${this.draggingRowIndex + 1} to ${droppedOnRowIndex + 1}`,
                duration:500
            })

            this.swapArrayElementsCUS1(this.dataBlParasiteMaster , this.draggingRowIndex ,droppedOnRowIndex )
            this.dataBlParasiteMaster[droppedOnRowIndex]['uuid'] = genUUID(10)
            this.dataBlParasiteMaster[this.draggingRowIndex]['uuid'] = genUUID(10)
            this.makeOrder()
        },
        makeOrder(){
            this.dataBlParasiteMaster.forEach((item, index) => {
                item['order_'] = index;
            });
        },






        closeResultBloodParasiteMaster(){
            this.isChkboxChangeResult = []
        },
        newSelectedResult(payload){

            // console.log(JSON.stringify( payload))
            //payload ---> {"no":1,"id":1,"data_res":{"id":["Negative","Positive"]}}

            // change into idEdit
            // ---> result_dat_aval
            // ---> result_dat_aval_id
            // into idEdit

            this.idEdit.result_dat_aval = payload.data_res
            this.idEdit.result_dat_aval_id = payload.id


        },
        defaultResult_WhenNewData(){
             
            axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
            axios.post(`${getBaseURLforBackEnd()}/api/list_of_result_blparasite_master`,getConfigAxios())
                    .then((res)=>{
                        // set member 0 is default
                        this.idEdit.result_dat_aval_id = res.data[0].id
                        this.idEdit.result_dat_aval  = res.data[0].data_res
                    })
                    .catch((err)=>{
                        this.isFullScreenLoading = false
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        this.$router.push('/login')
                            .catch(()=>{});
                    })
        },
        addNew(){
            this.idEdit =  Object.assign( {} ,DATA_BL_PARASITE_MODEL)
            this.modeTabNewEdit = 1
            this.mainTab = 1      
            // find default result
            this.defaultResult_WhenNewData()
            // set default enable
            this.idEdit.enable = true
            //
            this.isChkboxChangeResult = []
            //
            this.hasNameNotValid = false
            this.hasResultTypeNotValid = false
        },
        edit(payload){
            const tmp = this.dataBlParasiteMaster.find(dat=>dat.id === payload.id)
            // console.log(tmp)
            if(tmp){
                this.idEdit =  Object.assign( {} ,tmp)   // GOOD
            }
            this.modeTabNewEdit = 2
            this.mainTab = 1  
            //
            this.isChkboxChangeResult = []                         
        },
        loadDat(){
                const datTo = {
                    "admin" : true
                }
                this.isFullScreenLoading = true


                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/list_of_bl_parasite`,datTo,getConfigAxios())
                    .then((res)=>{
                        this.dataBlParasiteMaster = res.data
                        setTimeout(()=>{
                            this.isFullScreenLoading = false
                        },400)
                    })
                    .catch((err)=>{
                        this.isFullScreenLoading = false
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        this.$router.push('/login')
                            .catch(()=>{});
                    })
        },
        saveDat(){


                // check
                if ( !this.idEdit.result_dat_aval_id){
                     
                     this.hasResultTypeNotValid = true
                    return

                }

                if(!this.idEdit.name){
                    this.hasNameNotValid = true
                    return
                }
                    //   {
                    //           "mode" : 1,
                    //           "id_edit": 1 ,   
                    //           "dat" : { "name" : "test || ", "enable" : true ,"result_type": 1}
                    //     }

                    //  idEdit -->  { "id": "","name": "","result_dat_aval_id" : "","result_dat_aval": "" , "enable": false} , 


                     const datTo = {
                     
                              "mode" : this.modeTabNewEdit,
                              "id_edit": this.idEdit.id ,   
                              "dat" : { "name" : this.idEdit.name , "enable" : this.idEdit.enable ,"result_type": this.idEdit.result_dat_aval_id}
                 
                    }
                    // console.log(JSON.stringify(datTo))
                    this.isFullScreenLoading = true
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}/api/insert_or_update_blparasite`,datTo,getConfigAxios())
                    .then((res)=>{
                                        this.$buefy.toast.open({
                                            duration: 2500,
                                            message: `${res.data.msg}`,
                                            position: 'is-bottom',
                                            type: 'is-success'
                                        })
                                        this.loadDat()
                                        this.isFullScreenLoading = false
                                        this.mainTab = 0

                       
                    })
                    .catch((err)=>{
                        this.isFullScreenLoading = false
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        this.$router.push('/login')
                            .catch(()=>{});
                    })




                    this.isFullScreenLoading = false




        },
      
        close(){
            this.$emit('close')
        }
    },
    data(){
        return {
            isFullScreenLoading : false,
            dataBlParasiteLoaded : false,
            dataBlParasiteMaster : [],
            modeTabNewEdit: 1,
            mainTab : 0,
            isEmpty: false,

            idEdit : DATA_BL_PARASITE_MODEL ,//{ "id": "","name": "","result_dat_aval_id" : "","result_dat_aval": "" , "enable": false} ,
            hasMaxOverLenght : false,
            hasNameNotValid : false,
            hasResultTypeNotValid : false,

            isChkboxChangeResult : [],


            // hasNameError : false,
            // hasResultTypeError : false,
        }
    },
    watch :{
        isComponentModalActive :{
            immediate : true,
            handler: function(val){
                  if(val){
                    this.loadDat()

                  }
            }
        },
        // 'idEdit.name':{
        //     deep : true,
        //     handler: function(val){
        //          this.hasNameNotValid = !val 
        //     }
        // },
        'idEdit.result_dat_aval_id':{
            deep : true,
            handler: function(val){
                 this.hasResultTypeNotValid = !val 
            }
        }
    }
}
</script>